import { render, staticRenderFns } from "./AcordionItem.vue?vue&type=template&id=cf947bf8&"
import script from "./AcordionItem.vue?vue&type=script&lang=js&"
export * from "./AcordionItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports